<div class="statistics-page">
    <ng-container *ngIf="showStats">
    <h3>Leads</h3>
    <table>
        <tbody>
            <tr>
                <td>Total Leads</td>
                <td>{{responseData.totalLead}}</td>
            </tr>
            <tr>
                <td>Lost Leads</td>
                <td>{{responseData.loseLead}}</td>
            </tr>
  
    
    <h3>Clients</h3>
  
            <tr>
                <td>Total Clients</td>
                <td>{{responseData.totalClient}}</td>
            </tr>
            <tr>
                <td>Total Premium</td>
                <td>{{responseData.totalPremium}}</td>
            </tr>
            <tr>
                <td>Total Commission</td>
                <td>{{responseData.totalCommission}}</td>
            </tr>
        </tbody>
    </table>
    <div *ngIf="agentList.length">
        <button type="button" class="btn btn-primary btn-sm" (click)="openAgentView();">Agent View</button>
    </div>
</ng-container>

    <div>
        <ng-container *ngIf="showAgentList">
            <div class="card text-center">
                <div class="card-header">
                  Agent List
                </div>
                <div class="card-body">
                 <div class="table-responsive">
                    <table class="tableHover">
                        <thead>
                            <tr>
                                <th class="col-1">SL.</th>
                                <th class="col-4">Name</th>
                                <th class="col-4">Email</th>
                                <th class="col-3">Mobile</th>
                                </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let agent of agentList , index as i" (click)="agentStaticsData(agent);">
                                <td>{{i+1}}</td>
                                <td>{{agent.name}}</td>
                                <td>{{agent.email}}</td>
                                <td>{{agent.mobile}}</td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                </div>
             </div>
             <button type="button" class="btn btn-primary btn-sm closeAgent" (click)="closeAgentView();">Close List</button>
        </ng-container>
    </div>

    <div>
        <ng-container *ngIf="showAgentStats">
   <div>
       Name: {{agentDetails.name}}
   </div>
            <h3>Leads</h3>
            <table>
                <tbody>
                    <tr>
                        <td>Total Leads</td>
                        <td>{{agentResponseData.totalLead}}</td>
                    </tr>
                    <tr>
                        <td>Lost Leads</td>
                        <td>{{agentResponseData.loseLead}}</td>
                    </tr>
          
            
            <h3>Clients</h3>
          
                    <tr>
                        <td>Total Clients</td>
                        <td>{{agentResponseData.totalClient}}</td>
                    </tr>
                    <tr>
                        <td>Total Premium</td>
                        <td>{{agentResponseData.totalPremium}}</td>
                    </tr>
                    <tr>
                        <td>Total Commission</td>
                        <td>{{agentResponseData.totalCommission}}</td>
                    </tr>
                </tbody>
            </table>
            <button type="button" class="btn btn-primary btn-sm" (click)="backToAgentlist();">Back</button>
        </ng-container>

    </div>
    
</div>